module.exports = __webpack_public_path__ + "img/mountain-saturized-op5.05d9fb9a.png";